const ISP_SEGMENTS_SERVING_KEY = 'ISP_SEGMENTS_SERVING_KEY';
export default function setServingSegments(segmentRes) {
    if (segmentRes) {
        localStorage.setItem(ISP_SEGMENTS_SERVING_KEY, String(segmentRes));
    }
    else {
        localStorage.removeItem(ISP_SEGMENTS_SERVING_KEY);
    }
}
//# sourceMappingURL=setServingSegments.js.map